const DEFALUT_QUALITY = 0.8; // 默认的图片压缩质量
const ONE_KB = 1024; // 1KB大小
const ONE_MB = 5;
const DEFALUT_LIMITSIZE = ONE_MB * ONE_KB; // 默认的压缩临界大小，500KB
const CTX_WIDTH = 4000; // 画布宽
const CTX_HEIGHT = 4000; // 画布高

/**
 * @description: 压缩图片
 * @param {object} file 文件对象
 * @param {number} quality 压缩质量比例，取值0至1（与压缩质量有关，数值越小，质量越低）
 * @param {number} limitSize 高于该值将进行压缩，否则不压缩，单位：KB
 * @return {promise} 返回promise对象
 */
export function imageMinimize (file, quality = DEFALUT_QUALITY, limitSize = DEFALUT_LIMITSIZE) {
    return new Promise(resolve => {
        if (file.size <= limitSize * ONE_KB * ONE_KB) { // 判断图片是否大于预设的大小，是就直接上传
            resolve(file);
        } else { // 反之压缩图片
            const reader = new FileReader();
            // 将图片转成 base64 格式
            reader.readAsDataURL(file);
            // console.log(reader);
            // 读取成功后的回调
            reader.onloadend = function () {
                const result = this.result;
                const img = new Image();
                img.src = result;
                img.onload = function () {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    let targetWidth = img.width;
                    let targetHeight = img.height;
                    if (img.width > CTX_WIDTH || img.height > CTX_HEIGHT) {
                        if (img.width / img.height > CTX_WIDTH / CTX_HEIGHT) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = CTX_WIDTH;
                            targetHeight = Math.round(CTX_WIDTH * (img.height / img.width));
                        } else {
                            targetHeight = CTX_HEIGHT;
                            targetWidth = Math.round(CTX_HEIGHT * (img.width / img.height));
                        }
                    }
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                    const ndata = canvas.toDataURL('image/jpeg', quality);
                    resolve(dataURItoBlob(ndata, file.type));
                };
            };
        }
    });
};

/**
 * @description 将base64转换为文件对象
 * @param {string } dataURI 图片的base64编码
 * @param {string} type 图片类型
 * @returns {Object} 文件对象
 */
function dataURItoBlob (dataURI, type) {
    // 对base-64 编码的字符串进行解码
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    // Uint8Array 转换成2进制数组
    // Blob 转换成文件对象
    return new Blob([new Uint8Array(array)], { type: type });
}
